module.exports = new __parcel__URL__("Assassinskill_05.74120464.png").toString();